import React from "react";
import BaseCard from "./BaseCard";
import StatusBadge from "./StatusBadge";
import "./ModelCard.css";

/**
 * ModelCard
 * Analysis / model summary card used in dashboards.
 *
 * Props:
 * - title
 * - category
 * - status
 * - datasetLabel
 * - clientName?
 * - createdAt?
 * - accuracy?
 * - durationMinutes?
 * - onClick?
 * - onViewDetails?
 * - onDelete?
 */
function ModelCard({
  title,
  category,
  status,
  datasetLabel,
  clientName,
  createdAt,
  accuracy,
  durationMinutes,
  onClick,
  onViewDetails,
  onDelete,
}) {
  return (
    <BaseCard
      className="model-card"
      clickable={!!onClick}
      onClick={onClick}
    >
      <div className="model-card-header">
        <div className="model-card-title-section">
          <div className="model-card-icon">⚙</div>
          <div>
            <h4 className="model-card-title">{title}</h4>
            {category && (
              <p className="model-card-category">
                {String(category).replace(/_/g, " ")}
              </p>
            )}
          </div>
        </div>
        <StatusBadge status={status} size="sm" />
      </div>

      <div className="model-card-body">
        <div className="model-card-row">
          <span className="label">Dataset / Table</span>
          <span className="value">{datasetLabel || "—"}</span>
        </div>

        {clientName && (
          <div className="model-card-row">
            <span className="label">Client</span>
            <span className="value">{clientName}</span>
          </div>
        )}

        {createdAt && (
          <div className="model-card-row">
            <span className="label">Created</span>
            <span className="value">
              {new Date(createdAt).toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
                year: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
              })}
            </span>
          </div>
        )}

        {typeof accuracy !== "undefined" && accuracy !== null && (
          <div className="model-card-row">
            <span className="label">Accuracy</span>
            <span className="value">{accuracy || "N/A"}</span>
          </div>
        )}

        {durationMinutes && (
          <div className="model-card-row">
            <span className="label">Duration</span>
            <span className="value">
              {Math.round(durationMinutes)} min
            </span>
          </div>
        )}
      </div>

      {(onViewDetails || onDelete) && (
        <div className="model-card-footer">
          {onViewDetails && (
            <button
              className="btn btn-primary btn-sm"
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                onViewDetails();
              }}
            >
              View Details
            </button>
          )}
          {onDelete && (
            <button
              className="btn btn-danger btn-sm"
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                onDelete();
              }}
            >
              Delete
            </button>
          )}
        </div>
      )}
    </BaseCard>
  );
}

export default ModelCard;

